import script from "./CasesReturned.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasesReturned.vue?vue&type=script&setup=true&lang=ts"

import "./CasesReturned.vue?vue&type=style&index=0&id=d81f920a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d81f920a"]])

export default __exports__